import React from 'react';
import Icon from './Icon';
import PropTypes from 'prop-types';
import staging_flag from '../../assets/staging_flag.png';

const CLASS_NAMES = {
    STAGING_FLAG: 'main-header-staging-flag'
};

const UndertoneLogo = ({isStagingEnv}) => {
    return (
        <div className='undertone-logo'>
            <Icon icon='perion-logo.svg' />
            {isStagingEnv && <img src={staging_flag} className={CLASS_NAMES.STAGING_FLAG} alt='Staging Environment' />}
        </div>
    );
};

UndertoneLogo.propTypes = {
    isStagingEnv: PropTypes.bool
};

export default UndertoneLogo;